(function () {
  if (window.__ruEtaInit) {
    window.__ruEtaInit();
    return;
  }

  var TXT = {
    es: {
      dias: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      meses: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      fmt: function (D, dow, day, month) {
        return D.dias[dow] + ' ' + day + ' de ' + D.meses[month];
      }
    },
    en: {
      dias: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      meses: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      fmt: function (D, dow, day, month) {
        return D.dias[dow] + ', ' + D.meses[month] + ' ' + day;
      }
    }
  };

  function ymd(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  function ahoraEnZona(zona) {
    var fechaStr, horaStr;

    try {
      fechaStr = new Intl.DateTimeFormat('en-CA', { timeZone: zona }).format(new Date());
      horaStr = new Intl.DateTimeFormat('en-GB', {
        timeZone: zona,
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }).format(new Date());
    } catch (e) {
      var n = new Date();
      fechaStr = ymd(n);
      horaStr = String(n.getHours()).padStart(2, '0') + ':' + String(n.getMinutes()).padStart(2, '0');
    }

    var p = fechaStr.split('-');
    var h = horaStr.split(':');

    return {
      fecha: new Date(+p[0], +p[1] - 1, +p[2], 12, 0, 0),
      minutos: (+h[0]) * 60 + (+h[1])
    };
  }

  function makeEsLaborable(saltarFindes, festivos) {
    return function (d) {
      var wd = d.getDay();
      if (saltarFindes && (wd === 0 || wd === 6)) return false;
      return festivos.indexOf(ymd(d)) === -1;
    };
  }

  function calcularBox(box) {
    var dias = parseInt(box.getAttribute('data-dias'), 10);
    if (isNaN(dias)) dias = 2;

    var findes = box.getAttribute('data-findes') !== 'false';
    var zona = box.getAttribute('data-zona') || 'Europe/Madrid';
    var corte = (box.getAttribute('data-corte') || '').trim();
    var idioma = (box.getAttribute('data-idioma') || 'es').toLowerCase();
    var festStr = box.getAttribute('data-festivos') || '';
    var festivos = festStr
      .split(/[\s,;]+/)
      .map(function (s) { return s.trim(); })
      .filter(function (s) { return /^\d{4}-\d{2}-\d{2}$/.test(s); });

    var D = TXT[idioma] || TXT.es;
    var esLaborable = makeEsLaborable(findes, festivos);

    function siguienteLaborable(f) {
      var d = new Date(f.getTime());
      while (!esLaborable(d)) d.setDate(d.getDate() + 1);
      return d;
    }

    function sumar(f, n) {
      var d = new Date(f.getTime());
      var s = 0;
      while (s < n) {
        d.setDate(d.getDate() + 1);
        if (esLaborable(d)) s++;
      }
      return d;
    }

    var ahora = ahoraEnZona(zona);
    var base = ahora.fecha;
    var resultado;

    if (corte) {
      var c = corte.split(':');
      var corteMin = (+c[0]) * 60 + (+c[1]);
      if (esLaborable(base) && ahora.minutos >= corteMin) {
        base = siguienteLaborable(new Date(base.getTime() + 86400000));
        resultado = sumar(base, dias - 1 >= 0 ? dias - 1 : 0);
      } else {
        resultado = sumar(base, dias);
      }
    } else {
      resultado = sumar(base, dias);
    }

    return D.fmt(D, resultado.getDay(), resultado.getDate(), resultado.getMonth());
  }

  window.__ruEtaInit = function () {
    document.querySelectorAll('[data-ru-eta]').forEach(function (box) {
      var slot = box.querySelector('[data-ru-eta-date]');
      if (slot) slot.textContent = calcularBox(box);
      box.removeAttribute('hidden');
    });
  };

  if (!window.__ruEtaObserver && 'MutationObserver' in window) {
    window.__ruEtaObserver = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) {
          if (document.querySelector('[data-ru-eta][hidden]')) {
            window.__ruEtaInit();
            break;
          }
        }
      }
    });

    try {
      window.__ruEtaObserver.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.__ruEtaInit);
  } else {
    window.__ruEtaInit();
  }
})();
